import { render } from "./SpmPanelMenuItemCommand.vue?vue&type=template&id=385e9042"
import script from "./SpmPanelMenuItemCommand.vue?vue&type=script&lang=ts"
export * from "./SpmPanelMenuItemCommand.vue?vue&type=script&lang=ts"
script.render = render

export default script